import React from 'react';
import './Ye3.css';
import Footer from '../Footer/Footer';

function Ye3() {
  return (
    <div className='day1'>
      <div className='prog_header'>
        <h1 className='prog_header_kippra'>6TH KIPPRA ANNUAL REGIONAL CONFERENCE  </h1>
        <h1 className='prog_header_theme'>THEME: ACCELERATING ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN </h1>
        <h1 className='prog_header_theme'>KENYA</h1>
        <h1 className='prog_header_kippra'> YOUTH SIDE EVENT PROGRAMME  </h1>
      </div>
      <div>
      
        <table>
        <p style={{fontWeight: "bold"}}>Day 3</p>
          <thead>
            <tr>
              <th style={{ fontWeight: '600', textDecoration: 'none' }} colSpan="3">Friday: 23RD JUNE 2023</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th style={{ fontWeight: 'bold', textDecoration: 'none', backgroundColor: "white", color: "black" }} colSpan="3">THEME 4: CREATIVITY AND INNOVATIVE IDEAS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold" }}>8.30 - 9.00</td>
             <td></td>
              <td>Arrival and Registration  <br /> <br />
              Entertainment <br />
                </td>
            </tr>
            <tr>
              <td >9.00 - 9.15</td>
              <td > </td>
              <td >Prayer and recap of Day 2 and resolutions</td> {/* New empty column */}
            </tr>
            <tr>
              <td  >9.15 - 11.00</td>
              <td >  </td>
              <td style={{ fontWeight: "bold" }}>Participation of youth in sustaining economic resilience<br /> <br />
                                                <span style={{fontWeight :"normal"}}>
                                                •	Youth agenda for development </span> <br />
                                                <span style={{fontWeight: "normal", textIndent: "30%"}}>
                                              &nbsp; &nbsp; - Promoting Innovations for development and environmental sustainability <br />
                                                &nbsp;&nbsp;&nbsp; - Youth in climate action <br />
                                                &nbsp;&nbsp;&nbsp; - Kenya climate change working group. <br /> <br /> 
                                                <span style={{fontWeight: "normal"}}>Plenary – Role of youth in development and resilience of ASAL</span>
                                                  </span> </td> {/* New empty column */}
            </tr>
            <tr>
              <td  >11.00 - 11.30</td>
              <td >  </td>
              <td style={{ fontWeight: "bold" }}>TEA BREAK<br /> </td> {/* New empty column */}
            </tr>
            <tr>
              <td  >11.30 - 12.30</td>
              <td >  </td>
              <td style={{ fontWeight: "bold" }}>Promoting Innovations and Creative Economy by youth<br /> 
              <span style={{fontWeight: "normal"}}>How to monetize creative art and performance <br /> in spoken word, comedy, cultural songs, cultural dances, <br /> modern music and other arts. <br />
              •	Irrigation hub <br />
              •	Digital economy <br />
              •	Film production <br />
              </span> <br />

              <span style={{ fontWeight: "bold" }}>Innovation and entrepreneurship by youth (videos and physical)</span> <br />
                  <span style={{fontWeight: "normal"}}>•	Education <br />
                                                        •	Environmental <br />
                                                        •	Human-wildlife conflict <br />
                                                        •	Agriculture <br />
                                                          •	Manufacturing <br />
                                                          •	Health and nutrition <br />
                                                          •	Business <br />
</span>
               </td> {/* New empty column */}
            </tr>
            <tr>
              <td  >12.00 - 13.00</td>
              <td >  </td>
              <td style={{ fontWeight: "normal" }}>Youth communique reading<br /> </td> {/* New empty column */}
            </tr>
            <tr>
              <td style={{ fontWeight: "normal" }}>13.00 - 14.00</td>
             <td></td>
              <td style={{fontWeight:"bold"}}>LUNCH BREAK   <br />
                </td>
            </tr>
            <tr>
              <td >14.00 - 17.00</td>
              <td ></td>
              <td style={{ fontWeight: "normal" }}> Closing ceremony</td> {/* New empty column */}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Footer />
      </div>
    </div>
  )
}

export default Ye3;
